var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useRef, useCallback } from 'react';
import TooltipMessage from './TooltipMessage';
var Tooltip = function (_a) {
    var text = _a.text, children = _a.children, html = _a.html, arrow = _a.arrow, justify = _a.justify, position = _a.position, color = _a.color, transitionDuration = _a.transitionDuration, persistent = _a.persistent, props = __rest(_a, ["text", "children", "html", "arrow", "justify", "position", "color", "transitionDuration", "persistent"]);
    var wrapperRef = useRef(null);
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(null), rect = _c[0], setRect = _c[1];
    var handleMouseLeave = useCallback(function () { return setOpen(false); }, []);
    var handleMouseEnter = useCallback(function () {
        // content wrapped by tooltip may change size and position outside of tooltip control
        // have to calculate coordinates and size every time
        setRect(wrapperRef.current.getBoundingClientRect());
        setOpen(true);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "RUITooltip-Wrapper", style: { display: 'inline-block' }, ref: wrapperRef, onMouseLeave: handleMouseLeave, onMouseEnter: handleMouseEnter }, children),
        React.createElement(TooltipMessage, __assign({ open: open, text: text, html: html, arrow: arrow, justify: justify, position: position, color: color, transitionDuration: transitionDuration, anchorRect: rect, persistent: persistent }, props))));
};
Tooltip.defaultProps = {
    html: false,
    arrow: true,
    text: '',
    justify: 'center',
    position: 'top',
    color: 'neutral',
    transitionDuration: 0.3,
    persistent: false,
};
export { Tooltip as default, Tooltip };
